import React, { FormEvent, useState } from "react";
import { ArrowRight } from "lucide-react";
import { navigateWithinPortal } from "../routing/portalRoutes";

export function PortalSignInPage({
  onSignIn,
}: {
  onSignIn: (clinicianCode: string) => void;
}) {
  const [clinicianCode, setClinicianCode] = useState("");
  const normalizedClinicianCode = clinicianCode.trim().toUpperCase();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!normalizedClinicianCode) return;

    onSignIn(normalizedClinicianCode);
    navigateWithinPortal("/clinician-portal");
  };

  return (
    <main className="clinician-portal cp-sign-in">
      <div className="cp-sign-in__brand">
        <img src="/EduForAll.png" alt="Education For All" />
        <strong>Education for All</strong>
      </div>

      <section
        className="cp-sign-in__card"
        aria-labelledby="portal-sign-in-title"
      >
        <div className="cp-sign-in__content">
          <p className="cp-sign-in__eyebrow">Clinician Portal</p>
          <h1 id="portal-sign-in-title">Education for All Clinician Portal</h1>
          <p className="cp-sign-in__description">
            Enter your clinician code to access your client list and manage
            assigned homework.
          </p>

          <form className="cp-sign-in__form" onSubmit={handleSubmit}>
            <label htmlFor="clinician-code">Clinician code</label>
            <input
              id="clinician-code"
              type="text"
              value={clinicianCode}
              onChange={(event) => setClinicianCode(event.target.value)}
              placeholder="Enter your clinician code"
              autoComplete="off"
              autoCapitalize="characters"
              spellCheck={false}
              autoFocus
            />
            <button
              type="submit"
              className="cp-sign-in__submit"
              disabled={!normalizedClinicianCode}
            >
              Continue to Home
              <ArrowRight aria-hidden="true" />
            </button>
          </form>
        </div>
      </section>

      <p className="cp-sign-in__footer">Faith. Technology. Support.</p>
    </main>
  );
}
